<script setup>
import { computed } from 'vue';
import ChannelSelector from '../ChannelSelector.vue';

const props = defineProps({
  channel: {
    type: Object,
    required: true,
  },
  enabledFeatures: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['channelItemClick']);

const hasFbConfigured = computed(() => {
  return window.chatwootConfig?.fbAppId;
});

const hasInstagramConfigured = computed(() => {
  return window.chatwootConfig?.instagramAppId;
});

const isActive = computed(() => {
  const { key } = props.channel;
  const features = props.enabledFeatures || {};
  const hasFeatures = Object.keys(features).length > 0;

  // If no features defined, default to active for all basic channels
  if (!hasFeatures) {
    // Only disable channels that require external configuration
    if (key === 'facebook') {
      return hasFbConfigured.value;
    }
    if (key === 'instagram') {
      return hasInstagramConfigured.value;
    }
    // All other channels are active by default
    return true;
  }

  if (key === 'website') {
    return features.channel_website;
  }
  if (key === 'facebook') {
    return features.channel_facebook && hasFbConfigured.value;
  }
  if (key === 'email') {
    return features.channel_email;
  }

  if (key === 'instagram') {
    return features.channel_instagram && hasInstagramConfigured.value;
  }

  if (key === 'voice') {
    return features.channel_voice;
  }

  return [
    'website',
    'twilio',
    'api',
    'whatsapp',
    'sms',
    'telegram',
    'line',
    'instagram',
    'voice',
  ].includes(key);
});

const isComingSoon = computed(() => {
  const { key } = props.channel;
  // Show "Coming Soon" only if the channel is marked as coming soon
  // and the corresponding feature flag is not enabled yet.
  return ['voice'].includes(key) && !isActive.value;
});

const onItemClick = () => {
  if (isActive.value) {
    emit('channelItemClick', props.channel.key);
  }
};
</script>

<template>
  <ChannelSelector
    :title="channel.title"
    :description="channel.description"
    :icon="channel.icon"
    :is-coming-soon="isComingSoon"
    :disabled="!isActive"
    @click="onItemClick"
  />
</template>
